export default __webpack_public_path__ + "static/media/cat-lqMIN.jpg.14b958b3.txt";